import React from 'react';
import {
  Search, TrendingUp, HelpCircle, Building2, Star, Smartphone, Mail,
} from 'lucide-react';
import { Link } from 'react-router-dom';

const ICONS = { Search, TrendingUp, HelpCircle, Building2, Star, Smartphone, Mail };

export default function MarketingTipCard({ tip }) {
  const Icon = ICONS[tip.icon] || TrendingUp;
  return (
    <div
      className="relative bg-slate-900/60 border border-slate-800 rounded-2xl p-6 hover:border-emerald-500/40 transition-colors group"
      data-testid={`tip-${tip.number}`}
    >
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <div className="w-11 h-11 rounded-lg bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center">
            <Icon className="w-5 h-5 text-emerald-400" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-1">
            Tip #{tip.number}
          </p>
          <h3 className="text-lg font-bold text-white leading-snug">
            {tip.title}
          </h3>
          <p className="text-slate-300 text-sm mt-2 leading-relaxed">
            {tip.description}
          </p>
          {tip.articleSlug && (
            <Link
              to={`/blog/${tip.articleSlug}`}
              className="inline-flex items-center gap-1 mt-3 text-sm text-emerald-400 hover:text-emerald-300 font-medium"
              data-testid={`tip-article-link-${tip.number}`}
            >
              Leer guía completa →
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
